import { useEffect, useState } from "react";
import Skeleton from "./components/Skeleton";
import { useAuth } from "@clerk/clerk-react";
import { createApiClient } from "./api";

export default function Transactions() {
  const { getToken } = useAuth();
  const api = createApiClient(getToken);

  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchTransactions() {
      try {
        setError(null);
        setLoading(true);

        const res = await api.get("/api/transactions");
        setTransactions(res.data);
      } catch (err) {
        console.error("Failed to load transactions", err);
        setError("Failed to load transactions");
      } finally {
        setLoading(false);
      }
    }

    fetchTransactions();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (loading) {
    return (
    <div className="space-y-3">
      <Skeleton className="h-6 w-1/3" />
      <Skeleton className="h-10 w-full" />
      <Skeleton className="h-10 w-full" />
      <Skeleton className="h-10 w-full" />
      <Skeleton className="h-10 w-full" />
    </div>
  );
  }

  if (error) {
    return <p style={{ color: "red" }}>{error}</p>;
  }

  if (!loading && transactions.length === 0) {
  return (
    <div className="text-center py-10">
      <p className="text-sm text-gray-500">
        No transactions found yet.
      </p>
      <p className="text-sm text-gray-400 mt-1">
        Transactions will appear after your bank finishes syncing.
      </p>
    </div>
  );
}

  return (
  <div className="overflow-x-auto">
  <table className="w-full text-sm border-collapse">
    <thead>
      <tr className="border-b text-gray-500">
        <th className="py-2 text-left font-medium">Date</th>
        <th className="py-2 text-left font-medium">Description</th>
        <th className="py-2 text-right font-medium">Amount</th>
      </tr>
    </thead>
    <tbody>
      {transactions.map((t) => (
        <tr
          key={t.transaction_id}
          className="border-b last:border-0"
        >
          <td className="py-3">{t.date}</td>
          <td className="py-3 text-gray-800">{t.name}</td>
          <td className="py-3 text-right font-medium">
            ${Number(t.amount).toFixed(2)}
          </td>
        </tr>
      ))}
    </tbody>
  </table>
</div>

  );
}
